var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../img/logo.png")},on:{"click":_vm.gotohome}}),_vm._v("   "),_c('span',{staticStyle:{"font-weight":"800"}},[_vm._v("Photo Video")]),_vm._v("  "),_c('span',[_vm._v("Maker")])])
}
var staticRenderFns = []

export { render, staticRenderFns }